export default {
  toasts: {
    success: 'Gavekortet blev indløst.',
    error: 'Gavekortet kunne ikke indløses.',
  },
  title: 'Indløs gavekort',
  subtitle: 'Indtast gavekortkoden og det beløb, der skal indløses fra kundens regning.',
  form: {
    amount: {
      label: 'Beløb, der skal indløses',
    },
    code: {
      label: 'Gavekortkode',
    },
  },
  buttons: {
    redeem: 'Indløs',
    cancel: 'Annuller',
  },
};
